<template>
    <div class="rdpicker" ref="picker" :class="{'has-focus': isPickerOpen, mainClass}"
         v-closable="{
            exclude: ['picker'],
            handler: 'closePicker'
          }">
        <input ref="textinput" @change="handleInput" v-model="formatedValue" :placeholder="label" type="text"
               readonly="readonly"
               class="field-input" @click="togglePicker()">
        <a v-if="value" href="#" class="clear-btn" @click.prevent="clear()"><i class="la la-close"></i></a>
        <transition name="slide-fade">
            <div ref="panel" v-if="isPickerOpen" class="panel">
                <div class="picker-group">TIME PERIOD</div>
                <h5 v-for="shortcut in shortcuts"
                    :key="`shortcut-${shortcut.label}`"
                    :class="{selected: shortcut.isSelected}"
                    @click="selectPeriod(shortcut.value)">
                    {{shortcut.label}}
                </h5>
                <div class="picker-group">Choose a date</div>
                <Datepicker wrapper-class="rdpicker-datepicker"
                            format="yyyy-MM-dd"
                            placeholder="From"
                            :disabledDates="disabledDatesFrom" v-model="dobdtFrom"
                            v-ep-restrict.readonly
                            :typeable="false"
                            :required="true">
                </Datepicker>
                <Datepicker wrapper-class="rdpicker-datepicker"
                            format="yyyy-MM-dd"
                            placeholder="To"
                            :disabledDates="disabledDatesTo" v-model="dobdtTo"
                            v-ep-restrict.readonly
                            :typeable="false"
                            :required="true">
                </Datepicker>
                <div class="m--space-30"></div>
                <div class="text-center">
                    <button class="btn btn-primary m-btn--wide" @click="closePicker()">Search</button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import closable from './../filters/closable';
    import Datepicker from 'vuejs-datepicker';
    import InputFilter from './../filters/Input';

    InputFilter()
    closable()

    export default {
        props: {
            value: {
                type: [String, Object],
                default: null
            },
            label: {
                type: String,
                default: 'Select date'
            },
            mainClass: {
                type: String,
                default: ''
            }
        },
        model: {
            prop: 'value',
            event: 'change'
        },

        data() {
            return {
                dobdtFrom: null,
                dobdtTo: null,
                types: ['-isoWeek', '-isoMonth', '-iso3Month','-7d','-1m','-3m'],
                shortcuts: [{
                    label: 'Last week',
                    value: '-7d',
                    // value: '-isoWeek',
                    isSelected: false
                }, {
                    label: 'Last month',
                    value: '-1m',
                    // value: '-isoMonth',
                    isSelected: false
                }, {
                    label: 'Last 3 months',
                    value: '-3m',
                    // value: '-iso3Month',
                    isSelected: false
                }],
                disabledDatesFrom: {
                    // to: new Date()
                },
                disabledDatesTo: {
                    // to: new Date()
                },
                isPickerOpen: false
            }
        },
        methods: {
            selectRange() {
                this.shortcuts.filter((item) => {
                    item.isSelected = false
                })
                let from = this.dobdtFrom ? moment(this.dobdtFrom).format('YYYY-MM-DD') : null
                let to = this.dobdtTo ? moment(this.dobdtTo).format('YYYY-MM-DD') : null
                this.$emit('change', {
                    start: from,
                    end: to,
                    shortcut: null,
                })
            },
            selectPeriod(type) {
                this.shortcuts.filter((item) => {
                    if (item.value === type) {
                        item.isSelected = true
                    } else {
                        item.isSelected = false
                    }
                })
                let to = null
                let from = null
                switch (type) {
                    case '-isoWeek':
                        from = moment().startOf('isoWeek').subtract(7, 'days').format('YYYY-MM-DD')
                        to = moment().startOf('isoWeek').subtract(1, 'day').format('YYYY-MM-DD')
                        break;
                    case '-isoMonth':
                        from = moment().startOf('month').subtract(1, 'month').format('YYYY-MM-DD')
                        to = moment().startOf('month').subtract(1, 'day').format('YYYY-MM-DD')
                        break;
                    case '-iso3Month':
                        from = moment().startOf('month').subtract(3, 'months').format('YYYY-MM-DD')
                        to = moment().startOf('month').subtract(1, 'day').format('YYYY-MM-DD')
                        break;
                    case '-7d':
                        from = moment().subtract(1, 'week').format('YYYY-MM-DD')
                        to = moment().format('YYYY-MM-DD')
                        break;
                    case '-1m':
                        from = moment().subtract(1, 'month').format('YYYY-MM-DD')
                        to = moment().format('YYYY-MM-DD')
                        break;
                    case '-3m':
                        from = moment().subtract(3, 'months').format('YYYY-MM-DD')
                        to = moment().format('YYYY-MM-DD')
                        break;
                }
                this.$emit('change', {
                    start: from,
                    end: to,
                    shortcut: type,
                })
                this.closePicker()
            },
            clear() {
                this.dobdtFrom = null
                this.dobdtTo = null
                this.shortcuts.filter((item) => {
                    item.isSelected = false
                })
                this.$emit('change', null)
            },
            togglePicker() {
                this.isPickerOpen = !this.isPickerOpen
            },
            closePicker() {
                this.isPickerOpen = false
            },
            handleClick(value) {
                this.$emit('onClick', value);
                this.newTab = value;
            },
            handleInput(e) {
                this.$emit('change', this.content)
            }
        },
        mounted() {
        },
        watch: {
            dobdtFrom: function (val) {
                if (val !== null) {
                    this.disabledDatesTo = {
                        to: moment(val).toDate()
                    }
                    this.selectRange()
                }
            },
            dobdtTo: function (val) {
                if (val !== null) {
                    this.disabledDatesFrom = {
                        from: moment(val).toDate()
                    }
                    this.selectRange()
                }
            }
        },
        computed: {
            formatedValue: function () {
                if (this.value !== null) {
                    return `${this.value.start ? this.value.start.replace(/-/g, "/") : '...'} - ${this.value.end ? this.value.end.replace(/-/g, "/") : '...'}`
                } else {
                    return null
                }
            }
        },
        components: {
            Datepicker
        }
    }
</script>
<style>
    .rdpicker {
        position: relative;
    }

    .rdpicker .field-input {
        cursor: pointer;
        background-color: #fff;
        -webkit-transition-duration: .3s;
        transition-duration: .3s;
        position: relative;
        width: 100%;
        height: 42px;
        min-height: 42px;
        padding-left: 12px;
        padding-right: 44px;
        font-weight: 400;
        -webkit-appearance: none;
        outline: none;
        font-size: 14px;
        z-index: 0;
        border: 1px solid rgba(0, 0, 0, .2);
        border-radius: 0;
    }

    .rdpicker.has-focus .field-input {
        border: 1px solid rgb(142, 102, 218);
    }

    .rdpicker .clear-btn {
        color: #2d2d2d;
        position: absolute;
        top: 12px;
        right: 12px;
    }

    .rdpicker .clear-btn:hover {
        color: #ff570c;
        text-decoration: none;
    }

    .rdpicker .panel {
        position: absolute;
        top: 50px;
        width: 100%;
        height: auto;
        background-color: #fff;
        box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
        z-index: 40000;
        padding: 15px;
    }

    .rdpicker-datepicker {
        display: inline-block;
        margin-right: 20px;
    }

    .rdpicker-datepicker input {
        border: none;
        border-bottom: 1px solid #c1bcbc;
        padding-bottom: 7px;
        font-size: 16px;
    }
   .rdpicker-datepicker input:focus, .rdpicker-datepicker input:hover {
       outline: none;
       border-bottom: 1px solid #3b30ff;
   }
    .picker-group {
        font-size: 17px;
        font-weight: 500;
        color: #737373;
        margin-bottom: 15px;
    }

    .rdpicker h5 {
        margin-bottom: 20px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        color: #000;
    }

    .rdpicker h5.selected {
        color: #3b30ff;
        font-weight: 500;
    }

    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-leave-active {
        transition: all .3s ease;
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateY(10px);
        opacity: 0;
    }
</style>
